import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    forwardRef,
    Input,
    ViewEncapsulation,
} from '@angular/core';
import {
    ControlValueAccessor,
    NG_VALUE_ACCESSOR,
} from '@angular/forms';
import {
    ISuggestValue,
    SuggestDirection,
} from '@uipath/angular/components/ui-suggest';

import padStart from 'lodash-es/padStart';
import * as moment from 'moment';

@Component({
    selector: 'ui-datetime-picker',
    templateUrl: './ui-datetime-picker.component.html',
    styleUrls: ['./ui-datetime-picker.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => UiDateTimePickerComponent),
        multi: true,
    }],
    encapsulation: ViewEncapsulation.None,
})
export class UiDateTimePickerComponent implements ControlValueAccessor {
    @Input()
    public datePlaceholder = 'Date';

    @Input()
    public timePlaceholder = 'Time';

    @Input()
    public timePickerDirection: SuggestDirection = 'down';

    public get date(): moment.Moment | null {
        return this._value;
    }
    public set date(date: moment.Moment | null) {
        if (date == null) {
            this._value = null;
            this.onChange(this.value);
            return;
        }

        this._value =
            date.startOf('day')
                .date(date.date())
                .month(date.month())
                .year(date.year());
        this.time = this._time;

        this.onChange(this.value);
        this._cd.markForCheck();
    }

    public get time(): ISuggestValue[] {
        return this._time;
    }

    public set time(time: ISuggestValue[]) {
        const [hours, minutes] = time[0].text.split(':', 2);

        if (this._value) {
            this._value = this._value
                .hours(Number(hours))
                .minutes(Number(minutes));
        }

        this._time = time;
        this.onChange(this.value);
        this._cd.markForCheck();
    }

    public values: ISuggestValue[] = [];

    public get value() {
        return this._value ? this._value.toDate() : this._value;
    }
    private _value: moment.Moment | null = null;
    private _time: ISuggestValue[];

    constructor(
        private _cd: ChangeDetectorRef,
    ) {
        for (let i = 0; i < 24; i += 1) {
            for (let j = 0; j < 60; j += 15) {
                this.values.push({
                    id: `${i}:${j}`,
                    text: `${
                        padStart(i.toString(), 2, '0')
                        }:${
                        padStart(j.toString(), 2, '0')
                        }`,
                });
            }
        }
        this._time = [this.values[0]];
    }

    public onChange: (_: any) => void = () => { };
    public onTouch: () => void = () => { };

    public writeValue(date: Date) {
        if (!date) { return; }

        const value = moment(date);

        // discard seconds & milliseconds
        value.startOf('minute');
        const hours = value.hours();
        const minutes = Math.floor(
            value.minutes() / 15,
        ) * 15;
        value.minutes(minutes);

        this._time = [this.values.find(v => v.id === `${hours}:${minutes}`)!];
        this._value = value;
        this._cd.markForCheck();
    }

    public registerOnChange(fn: (_: any) => void): void {
        this.onChange = fn;
    }

    public registerOnTouched(fn: () => void): void {
        this.onTouch = fn;
    }
}
